import { render, staticRenderFns } from "./JUpload.vue?vue&type=template&id=8cf8752c"
import script from "./JUpload.vue?vue&type=script&lang=js"
export * from "./JUpload.vue?vue&type=script&lang=js"
import style0 from "./JUpload.vue?vue&type=style&index=0&id=8cf8752c&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cf8752c')) {
      api.createRecord('8cf8752c', component.options)
    } else {
      api.reload('8cf8752c', component.options)
    }
    module.hot.accept("./JUpload.vue?vue&type=template&id=8cf8752c", function () {
      api.rerender('8cf8752c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JUpload.vue"
export default component.exports